import {
    GetterTree,
    MutationTree,
    ActionTree,
    Module,
} from 'vuex';
import api from '@/services/api/deploymentapi';

const state: any = {
    projects: [],
    project: null,
    timeseries: [],
    loadTimeseries: false,
    loadProjects: true,
    errorProjects: null,
    errorTimeseries: null,
};

const getters: any = {
    getProjects: (state: any) => state.projects,
    getLoadsProjects: (state: any) => state.loadProjects,
    getTimeseries: (state: any) => state.timeseries,
    getErrorProject: (state: any) => state.errorProjects,
    getErrorTimeseries: (state: any) => state.errorTimeseries,
    getLoadTimeseries: (state: any) => state.loadTimeseries,
};

const mutations: any = {
    SET_PROJECTS: (state: any, projects: any[]) => {
        state.projects = projects;
    },
    SET_TIMESERIES: (state: any, timeseries: any[]) => {
        state.timeseries = timeseries;
    },
    ERROR_PROJECTS: (state: any, error: Error) => {
        state.errorProjects = error;
    },
    ERROR_TIMESERIES: (state: any, error: Error) => {
        state.errorTimeseries = error;
    },
    LOAD_TIMESERIES: (state: any, loading: boolean) => {
        state.loadTimeseries = loading;
    },
    LOAD_PROJECTS: (state: any, loading: boolean) => {
        state.loadProjects = loading;
    },
};

const actions: any = {
    GET_PROJECTS: async (context: any) => {
        const token = context.rootState.auth.deploymentAuth.access_token;
        let projects;
        context.commit('LOAD_PROJECTS', true);
        try {
            projects = await api.get('user/projects', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            projects = projects.data;
            context.commit('SET_PROJECTS', projects.map((projectContext: any) => projectContext.project));
            context.commit('ERROR_PROJECTS', null);
            context.commit('LOAD_PROJECTS', false);
            return projects.data;

        } catch (error) {
            context.commit('ERROR_PROJECTS', error);
            context.commit('LOAD_PROJECTS', false);
            return error;
        }
    },
    GET_TIMESERIES: async (context: any, { start, end, datapoint, project, samplerate }) => {
        const token = context.rootState.auth.deploymentAuth.access_token;
        let timeseries;
        context.commit('LOAD_TIMESERIES', true);
        try {
            timeseries = await api.get('datapoint/timeseries', {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    dataPointID: datapoint,
                    project_id: project,
                    start,
                    end,
                    short: true,
                    samplerate,
                }
            });
            context.commit('SET_TIMESERIES', timeseries.data);
            context.commit('ERROR_TIMESERIES', null);
            context.commit('LOAD_TIMESERIES', false);
            return timeseries.data;
        } catch (error) {
            context.commit('ERROR_TIMESERIES', error);
            context.commit('LOAD_TIMESERIES', false);
            return error;
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions,
} as Module<any, any>;